import React from 'react';
import useTextContents from 'common/hooks/useTextContents'
import ButtonBackToPartner from 'components/Buttons/ButtonBackToPartner/ButtonBackToPartner'
import { BACK_TO_PARTNER_LINK_TYPES } from 'components/Buttons/ButtonBackToPartner/BackToPartnerButtonProps'

import SuccessPageHeadingIcon from '../../assets/icons/success-page-heading-icon.svg'
import './SuccessPageStyles.scss'


/**
 * Komponent obsługujący stronę "Decyzja pozytywna" 
*/
const SuccessPage = (): JSX.Element => {

   const successPageTextContents = useTextContents()

   return (
      <div className='success-page-outer-wrapper'>
         <img className='success-page-heading-icon' src={SuccessPageHeadingIcon} alt='sukces'/>
         <h1 className='success-page-heading-text'>{successPageTextContents('successPage.header')}</h1>
         <div className='success-page-description-text-wrapper'>
            <p>{successPageTextContents('successPage.mainContent')}</p>
         </div>
         <ButtonBackToPartner linkType={BACK_TO_PARTNER_LINK_TYPES.SUCCESS} />
      </div>
   )
}

export default SuccessPage